var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"choice-button",class:{
    'button-active': _vm.isActive,
  },attrs:{"depressed":"","x-large":"","width":_vm.width || null}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }